import ToggleButton from '@/components/ui/ToggleButton'

interface MinimalDetailToggleProps {
  detailView: boolean
  onToggle: (detailView: boolean) => void
  className?: string
}

export default function MinimalDetailToggle({ detailView, onToggle, className = '' }: MinimalDetailToggleProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className={`text-sm font-medium ${!detailView ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-400'}`}>
        Minimal
      </span>
      <ToggleButton
        enabled={detailView}
        onClick={() => onToggle(!detailView)}
        size="sm"
      />
      <span className={`text-sm font-medium ${detailView ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-400'}`}>
        Detail
      </span>
    </div>
  )
}
